import React, { Component } from 'react';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from "../../utils/util";
import Responsive from 'react-responsive';
import StoriesShowItem from '../AA/plan/storiesShowItem'
import Slider from 'react-slick';
import * as HttpUtils from "../../utils/http";
import Api from '../../utils/api';
import StepsNewQuiz from '../onboardingAA/StepsNewQuiz';
import GateFeeBoarding_pay from '../onboardingAA/GateFeeBoarding_pay';
import GateFeeBoarding_thank from '../onboardingAA/GateFeeBoarding_thank';
import GateFeeBoarding_dashboard from '../onboardingAA/GateFeeBoarding_dashboard';


import './OnboardingContainerAA.css';


function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-right"}
        onClick={onClick}
      />
    );
}

function SamplePrevArrowPhone(props) {
    const { className, style, onClick } = props;
    return (
      <div
        onClick={onClick}
      />
    );
}

  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slick-arrow custom-arrow-left"}
        onClick={onClick}
      />
    );
}

class GateFeeBoarding extends Component {
    constructor(props) {
        super(props);
        this.changeStepStep = this.changeStepStep.bind(this);
        this.state = {
            modeStep:1,
            storiesSettings:{
                dots: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows:true,
                prevArrow: <SamplePrevArrow />,
                nextArrow: <SampleNextArrow />,
                fade: true,
                autoplay: true,
                autoplaySpeed:4000,

                // fade: true,
                // pauseOnHover: false,

                customPaging: function(i) {
                    return (
                        <i className="custom-dots-s"></i>
                    );
                },
                dotsClass: "slick-dots slick-thumb",
                responsive: [
                    {
                      breakpoint: 766,
                      settings: {
                        dots: false,
                        infinite: true,
                        speed: 600,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: false,
                        prevArrow: <SamplePrevArrowPhone></SamplePrevArrowPhone>,
                        nextArrow: <SampleNextArrow />,
                      }
                    }
                ]    
            },
            storiceData:[
                {
                    name:'Kitera D.',
                    textData:'“The best part is she listened to what I wanted and only recommended those things instead of trying to sell me on a whole new routine. That leaves me feeling like HelloAva actually cares about helping their customers.”',
                    roundImg:'./images/plan/stories/storiesIcon3.svg',
                    realImg:'./images/plan/real/pc/1.jpg',
                    realImg_mobile:'./images/plan/real/mobile/1.jpg',
                },
                {
                    name:'Tiffany S',
                    textData:'“Mandy was very informative and helpful with my specific needs! She really made me feel like comfortable and that she wanted to make sure I was able to get what I was looking for. ”',
                    roundImg:'./images/plan/stories/storiesIcon6.svg',
                    realImg:'./images/plan/real/pc/2.jpg',
                    realImg_mobile:'./images/plan/real/mobile/2.jpg',
                },
                {
                    name:'Nicole C',
                    textData:'“It went amazingly! My favorite part was how kind and encouraging Mandy was! My skincare concerns were so validated and I felt so uplifted.”',
                    roundImg:'./images/plan/stories/storiesIcon8.svg',
                    realImg:'./images/plan/real/pc/3.jpg',
                    realImg_mobile:'./images/plan/real/mobile/3.jpg',
                },
                {
                    name:'Derek F.',
                    textData:'“Really felt as though she was listening to my concerns and gave me great detail about things to use, to reduce, and things to implement into routine. Fantastic”',
                    roundImg:'./images/plan/stories/storiesIcon2.svg',
                    realImg:'./images/plan/real/pc/4.jpg',
                    realImg_mobile:'./images/plan/real/mobile/4.jpg',
                },
                {
                    name:'Elisabeth C',
                    textData:'“Kathleen was really easy to talk to and helped me identify what I was missing in my routine. She made great suggestions on how to build my routine and listened to my concerns, my preferences and had a great assessment of my skin.”',
                    roundImg:'./images/plan/stories/storiesIcon5.svg',
                    realImg:'./images/plan/real/pc/5.jpg',
                    realImg_mobile:'./images/plan/real/mobile/5.jpg',
                },
                {
                    name:'Olivia H.',
                    textData:'“Kathleen was really thorough in going over my current skincare regimen and kindly explaining what I need to change and why. She was very knowledgeable about what ingredients and products would be best for my skin type.”',
                    roundImg:'./images/plan/stories/storiesIcon4.svg',
                    realImg:'./images/plan/real/pc/6.jpg',
                    realImg_mobile:'./images/plan/real/mobile/6.jpg',
                },
                {
                    name:'Michelle M',
                    textData:'“Kathleen was such a kind presence, and she was very knowledgeable! We had a great dialogue on my current routine and my concerns. Shortly after our call, I had personalized recommendations that actually get me super excited for my skincare routine!”',
                    roundImg:'./images/plan/stories/storiesIcon7.svg',
                    realImg:'./images/plan/real/pc/7.jpg',
                    realImg_mobile:'./images/plan/real/mobile/7.jpg',
                },
                {
                    name:'Kelsey P.',
                    textData:'“It was really nice to show her what I actually was using because I was at home. She took into account my budget and what my needs and wants were. I wanted a simple routine so she didn’t recommend things I didn’t need.”',
                    roundImg:'./images/plan/stories/storiesIcon1.svg',
                    realImg:'./images/plan/real/pc/8.jpg',
                    realImg_mobile:'./images/plan/real/mobile/8.jpg',
                },
            ],

        }
    }

    componentWillMount() {
        this.fun_stepManager();
       // 用户信息没缓存起来，就重新获取下
       if(!localStorage.getItem("user_global_phone") && localStorage.getItem("auth_token")){
            Api.getGenderId()
        }
    }

    fun_stepManager(){
        const userId = localStorage.getItem("user_id");
        let visited_scheduleConsult = localStorage.getItem("visited_scheduleConsult");

        if (!userId) {
            this.props.history.push('/signin');
        } else {
            if (localStorage.getItem('temp_new_user_flag')) {
                localStorage.removeItem('temp_new_user_flag');
            }

            if(localStorage.getItem("gateFeePaid") == "false"){
                this.setState({modeStep : 1 });
            }else if(localStorage.getItem("gateFeePaid") == "true" || this.state.gateFeePaid == true){
                if(visited_scheduleConsult == "true"){
                    this.setState({modeStep : 4 });   // 已经提交了计划咨询直接到 view 4
                }else{
                    this.setState({modeStep : 3 });// 已经付了咨询费，直接看到步骤3
                }
            }else{
                this.checkIfPaidGateFee();
            }
        }
    }

    changeStepStep(type) {
        let modeStep = this.state.modeStep;
        if(type == "back"){
            modeStep--;
        }else{
            modeStep++;
        }
        if(modeStep == 3){
            document.documentElement.scrollTop = 0;
            this.setState({modeStep:modeStep},()=>{
            })
            this.checkIfPaidGateFee();
        }else{
            document.documentElement.scrollTop = 0;
            this.setState({modeStep:modeStep})
        }
    }

    checkIfPaidGateFee() {
        const userId = localStorage.getItem("user_id");
        HttpUtils.get('/api/user-flags/gate-fee-paid?user-id=' + userId).then((response)=>{
            if (response) {
                this.setState({ showThankYou: true,gateFeePaid: true},()=>{
                    localStorage.setItem("gateFeePaid",true)
                    this.fun_stepManager();
                });
            }else{
                this.setState({gateFeePaid: false},()=>{
                    localStorage.setItem("gateFeePaid",false)
                    this.fun_stepManager();
                });
            }
        }).catch(function(err) {
            console.log("There was a problem checking payment status. Please try again.");
        });
    }

    render() {
        if(this.state.modeStep == 1){
            return (
                <div className={"skinQuiz-wrapper"}>
                   <StepsNewQuiz stepsTitel = {'Personalize your routine'} step={1} stepsSum={4}></StepsNewQuiz>
                    <div className="GateFeeBoarding-container">
                        <div className="top-thanks-container">
                                <Responsive maxWidth={ 767}>
                                    <div name="top-thanks-title-container">
                                            <div className="top-thanks-title">
                                                <i className="icon-hook"></i>
                                                <span className="top-thanks-title-text">Profile info saved</span>
                                            </div>
                                            <div className="HelloAva5-mobil-style">
                                                <img src="/images/onboardingAA/gateFeeBoarding/HelloAva-5.png"></img>
                                            </div>
                                    </div>
                                </Responsive>
                            <div className="ga-title-thanks-container navy">
                                <div className="ga-title-thanks-text-area">
                                    <div className="paragraphSemiBold0 ga-title-thanks-text-title">Thanks for sticking with us!</div>
                                    <div className="paragraphRegular3 ga-title-thanks-text-info">Now meet your dedicated esthetician to build your perfect routine</div>
            
                                    <div className="ga-title-thanks-money-area">
                                        <span className="ga-title-thanks-money">$10</span>
                                        <div className="ga-title-thanks-money-info">Consultation fee will be <br></br> credited toward your purchase</div>
                                    </div>
                                    <Responsive minWidth={ 767}>
                                            <button style={{width:'270px',marginTop:'45px'}} onClick={this.changeStepStep} className="p-a-n-button">Continue</button>
                                        </Responsive>
                                </div>
                                <Responsive minWidth={ 767}>
                                        <img className="ga-title-thanks-text-img" src="/images/onboardingAA/gateFeeBoarding/HelloAva-5-pc.png"></img>
                                </Responsive>
                            </div>
                        </div>
        
                        <div className="process-description-container">
                            <div className="paragraphSemiBold0 process-description-title">What happens next?</div>
                            <div className="process-description-info-area">
                                <div className="process-description-info-area-item">
                                    <img className="pd-info-area-item-img" src="/images/onboardingAA/gateFeeBoarding/sneak1.png"></img>
                                    <span className="pd-info-area-item-text">1. Schedule your 1-on-1 virtual skin consultation</span>
                                </div>
            
                                <div className="process-description-info-area-item">
                                        <img className="pd-info-area-item-img" src="/images/onboardingAA/gateFeeBoarding/sneak2.png"></img>
                                        <span className="pd-info-area-item-text">2. Gain access to your skin profile and learn how to care for it from a pro</span>
                                </div>
            
                                <div className="process-description-info-area-item">
                                        <img className="pd-info-area-item-img" src="/images/onboardingAA/gateFeeBoarding/sneak3.png"></img>
                                        <span className="pd-info-area-item-text">3. Best of ALL: Buy your recommended products for 15% off retail price</span>
                                </div>
                            </div>
                        </div>
        
                        <div className="risk-free-container">
                                <span className="paragraphSemiBold0 rfc-title">Try it Risk-free</span>
                                <div className="paragraphRegular3 rfc-conten-text">We are confident in our selections for you. Try them, test them out, and if there’s anything you don’t love, send them back.</div>
                                <Responsive minWidth={ 767}>
                                        <button style={{width:'270px',marginTop:'45px'}} onClick={this.changeStepStep} className="p-a-n-button">Continue</button>
                                </Responsive>
                        </div>
        
                        <div className="plan-area-style stories-show-zone" style={ isMobile(navigator.userAgent) ? {marginTop:'0'} :null  }>
                                <Responsive minWidth={ 767 }>
                                    <div className="skin-type-hello-title rfc-title" style={{marginBottom:'1.7em'}}>Real stories, unedited</div>
                                </Responsive>
                                <div style={{maxWidth:'1440px'}}>
                                    <div className="stories-show-area" style={{marginTop:'0'}}>
                                        <Slider { ...this.state.storiesSettings }>
                                            {
                                                this.state.storiceData.map((item, index)=>{
                                                    return <StoriesShowItem boardingGatefeeType={true} data={item} key={index} index={ index }></StoriesShowItem>
                                                })
                                            }
                                        </Slider>
                                    </div>
                                </div>
                        </div>
                        <Responsive maxWidth={ 767}>
                            <button style={{width:'270px',marginTop:'45px'}} onClick={this.changeStepStep} className="p-a-n-button continue-button-mobile">Continue</button>
                        </Responsive>    
                    </div>

                </div>
            )
        }else if(this.state.modeStep == 2){
            return ( 
                <div className={"skinQuiz-wrapper"} id="newBoarding_pay_View">
                    <StepsNewQuiz stepsTitel = {'Personalize your routine'} step={2} stepsSum={4}></StepsNewQuiz>
                    <GateFeeBoarding_pay fun_changeStepStep = {this.changeStepStep}></GateFeeBoarding_pay> 
                </div>
                );
        }else if(this.state.modeStep == 3){
            return (
                <div className={"skinQuiz-wrapper"} style={{top:'93px',zIndex:49 }} name="newBoardingThankView">
                    <StepsNewQuiz style={{top:'44px'}} stepsTitel = {'Personalize your routine'} step={3} stepsSum={4}></StepsNewQuiz>
                    <GateFeeBoarding_thank fun_changeStepStep = {this.changeStepStep}></GateFeeBoarding_thank>
                </div>
            )
        }else if(this.state.modeStep == 4){
            return (
                <div className={"skinQuiz-wrapper"} style={{top:'93px',zIndex:49}} name="newBoardingThankView">
                    <StepsNewQuiz stepsTitel = {'Personalize your routine'} step={4} stepsSum={4}></StepsNewQuiz>
                    <GateFeeBoarding_dashboard></GateFeeBoarding_dashboard>
                </div>
            );
        }else {
            return (
                <div className={"skinQuiz-wrapper"} style={{top:'93px',zIndex:49}} name="newBoardingThankView">
                    <StepsNewQuiz stepsTitel = {'Personalize your routine'} step={4} stepsSum={4}></StepsNewQuiz>
                    <GateFeeBoarding_dashboard></GateFeeBoarding_dashboard>
                </div>
            );
        }
    }
}

export default withRouter(connect()(GateFeeBoarding))



// WEBPACK FOOTER //
// ./src/views/onboardingAA/GateFeeBoarding.js